import styled from 'styled-components';

import { Button } from 'components/Button';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  margin-left: 15rem;
`;

const ButtonAdd = styled(Button)`
  width: 16rem;
`;

const ButtonRemove = styled(Button)`
  margin-left: auto;
`;

export { ButtonRemove, Container, ButtonAdd };
